import React, {useEffect} from 'react';
import {useTheme} from "../../common/ProjectThemeProvider";
import {Keys} from "../config/AppConfig";
import {GridBox, Image} from "../../common/fusion-ui";
import {checkNullStr, getJsonValue} from "../../common/fusion-ui/utils/ReactUtils";
import Section from "../../common/fusion-ui/view/Section";
import {useSubdomainData} from "../context/SubdomainProvider";
import useScreenSize from "../../common/fusion-ui/hook/useScreenSize";
import {AnimationType, FramerAnimator} from "../../common/fusion-ui/animation/FramerAnimator";

const VokMsgBox = React.memo(({
                                  className = "",
                              }) => {
    const TAG = "VokMsgBox";

    const theme = useTheme();
    const {subdomainData} = useSubdomainData();
    const {isScreenUpSm} = useScreenSize();

    const animator = new FramerAnimator();

    useEffect(() => {
        console.log(TAG, 'useEffect.subdomainData:', subdomainData);
    }, []);

    return (<>
        {(checkNullStr(getJsonValue(subdomainData, Keys.subdomain_DescriptionImg)) && checkNullStr(getJsonValue(subdomainData, Keys.subdomain_Description))) &&
            animator.setAnimationType(AnimationType.FADE_IN).render(
                <Section
                    className={`m-0 py-2 px-3 my-1 mb-2 h-auto ${className}`}
                    borderless={true}
                    shadowVariant={'sm'}
                    bg={'x'}
                >
                    <GridBox className={'px-3 py-3 al-start-sm jc-center-sm'} gap={0} sm={[12, 12]} md={[2, 10]}
                             alignAt={'center'} justifyAt={'start'}>
                        <Image
                            wrapperClassName={'jc-center py-2x m-0 p-0'}
                            className={'rounded-4'}
                            src={getJsonValue(subdomainData, Keys.subdomain_DescriptionImg)}
                            // width={isScreenUpSm ? '150px' : '100px'} - change made by Vandit (25/10/2024) set width in false condtion to 100% means when in bigger devices the image take width 100% of its parent's div so it not overflow and touch with text
                            width={isScreenUpSm ? '150px' : '100%'}
                            height={'auto'}
                            // maxWidth={'100px'}
                            // maxHeight={'100px'}
                            disableDrag={true}
                            objectFit={'cover'}
                        />

                        <div className={'m-0 p-0 px-2 text-block w-100 text-wrap'}
                             style={{color: theme.text}}
                             dangerouslySetInnerHTML={{__html: getJsonValue(subdomainData, Keys.subdomain_Description)}}/>
                    </GridBox>
                </Section>
            )
        }
    </>)

    function fun() {

    }
});
export default VokMsgBox;
